import { AxiosResponse } from "axios";
import BaseAPI from "../api";

const path: string = "/leave";

export type listType = {
  leave_status?: string;
  degree?: string;
  faculty?: string;
  date_of_issue?: string;
  year_graduated?: string;
  status?: string;
  created_id?: string;
  created_date?: string;
  modified_id?: string;
  modified_date?: number;
  type?: string;
  keyword?: number;
  limit?: number;
  page?: number;
};

export class leaveFormApi extends BaseAPI {
  static getAllLeaveForm(query: listType): Promise<any> {
    return this.api.get(`${path}/form`, {
      params: { ...query },
    });
  }

  static exportDocument(id_leave: number, token: string, form: string): Promise<AxiosResponse> {
    return this.api.get(`${path}/${id_leave}/pdf/${token}`, {
      responseType: "arraybuffer",
      params: { form }
    })
  }
}
